function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16pt",
    height: "15pt",
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(67.843137%,58.431373%,28.627451%)",
      fillOpacity: 1
    },
    d: "M 14 0.695312 C 10.480469 -1.683594 6.964844 2.941406 3.445312 1.332031 L 3.445312 0.992188 C 3.445312 0.566406 3.074219 0.222656 2.621094 0.222656 C 2.167969 0.222656 1.800781 0.566406 1.800781 0.992188 L 1.800781 14.238281 C 1.800781 14.664062 2.167969 15.011719 2.621094 15.011719 C 3.074219 15.011719 3.445312 14.664062 3.445312 14.238281 L 3.445312 8.628906 C 6.789062 10.15625 10.132812 6.054688 13.480469 7.6875 C 13.632812 7.761719 13.820312 7.757812 13.96875 7.671875 C 14.117188 7.585938 14.207031 7.433594 14.207031 7.269531 C 14.207031 5.207031 14.207031 3.140625 14.207031 1.074219 C 14.207031 0.925781 14.132812 0.78125 14 0.695312 Z M 14 0.695312 "
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon_flag.5f8723c2.svg";
export { ForwardRef as ReactComponent };